// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".brazil-checkbox-field[data-v-7f938ee4]{display:block;color:#333}.brazil-checkbox-field label[data-v-7f938ee4]:hover,.brazil-checkbox-field input[data-v-7f938ee4]:hover{cursor:pointer}label[data-v-7f938ee4]{display:flex}label input[data-v-7f938ee4]{margin-right:1em}", ""]);
// Exports
module.exports = exports;
